module.exports = __webpack_public_path__ + "static/Optimise circle-b8273369d3265e54d4b5b12f11258bfd.png";